import MapBoxGL from 'mapbox-gl'
import { DependencyList, useMemo } from 'react'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - FIXME (tchow 2025/03/12): Remove current comment when upgrading to react 19
import { createRoot } from 'react-dom/client'

export class ComponentControl {
  map: MapBoxGL.Map | undefined
  container: HTMLElement
  component: React.ReactElement

  constructor(component: React.ReactElement) {
    this.component = component
    this.container = document.createElement('div')
    this.container.className = 'mapboxgl-ctrl'
  }

  onAdd(map: MapBoxGL.Map) {
    this.map = map
    const root = createRoot(this.container)
    root.render(this.component)
    return this.container
  }
  onRemove() {
    this.container?.parentNode?.removeChild(this.container)
    this.map = undefined
  }
}

function useComponentControl(
  child: React.ReactElement<any, string | React.JSXElementConstructor<any>>,
  deps: DependencyList | undefined
) {
  return useMemo(() => new ComponentControl(child), deps)
}

export default useComponentControl
